module.exports = __webpack_public_path__ + "static/media/UNKNOWN.adef7796.svg";